
            import { registerOrcaWebServiceWorker } from '/src/api/sw/registerServiceWorker.ts';

            window.addEventListener('load', () => {
                registerOrcaWebServiceWorker();
            });
        